"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.brief.topic': 'Tema / brief',
    'socialMediaPlan.brief.topicPlaceholder': 'p.ej. Nueva colección de verano...',
    'socialMediaPlan.brief.goal': 'Objetivo',
    'socialMediaPlan.brief.tone': 'Tono',
    'socialMediaPlan.brief.contentType': 'Tipo de contenido',
    'socialMediaPlan.brief.contentType.image': 'Imagen',
    'socialMediaPlan.brief.contentType.carousel': 'Carrusel',
    'socialMediaPlan.brief.contentType.video': 'Video',
    'socialMediaPlan.brief.contentType.story': 'Historia',
    'socialMediaPlan.brief.contentType.thread': 'Hilo',
    'socialMediaPlan.brief.audience': 'Público objetivo',
    'socialMediaPlan.brief.cta': 'CTA',
    'socialMediaPlan.brief.ctaPlaceholder': 'p.ej. Comprar ahora, Saber más, Registrarse...',
    'socialMediaPlan.brief.platforms': 'Plataformas objetivo',
    'socialMediaPlan.brief.platformsHint': 'La IA ajustará la longitud, el estilo y los hashtags por separado para cada plataforma seleccionada.',
};
